import { FLABEL } from '@containers/Fireboard/fireboardVariables';
import Popup from './Popup';
import PopupContent from './PopupContent/index';

function getPopupConfig(type, onOk) {
   switch (type) {
      case 'success':
         return {
            type: 'popup',
            heading: 'Request complete',
            message: FLABEL().LOADER_SUCCESS_MESSAGE,
            buttons: [
               {
                  text: 'OK',
                  onClick: onOk
               }
            ]
         }

      default:
         return {
            type: 'spinner',
            heading: FLABEL().LOADER_PROCESSING_REQUEST,
            message: FLABEL().LOADER_SPINNER_MESSAGE
         }
   }
}

export { Popup, getPopupConfig, PopupContent }